(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7542],{

/***/ 22059:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/open-position/[pool-address]",
      function () {
        return __webpack_require__(23953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13970);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_CustomNumericFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25192);
/* harmony import */ var _utils_use_event_callback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88095);





const BaseAmountInput = (param)=>{
    let { inputProps , maxLimit , decimals =9 , debounceMilliseconds , ...props } = param;
    const onInputFocus = (0,_utils_use_event_callback__WEBPACK_IMPORTED_MODULE_3__/* .useEventCallback */ .$)((event)=>{
        if (Number(event.target.value) === 0) {
            event.target.select();
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        inputComponent: _components_base_CustomNumericFormat__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        placeholder: "0",
        inputProps: {
            "aria-label": "0",
            className: "p-0 text-xl iw:text-[#000E0F] font-semibold",
            min: 0,
            ...inputProps || {},
            decimalScale: decimals,
            allowNegative: false,
            thousandSeparator: ",",
            inputMode: "decimal",
            maxLimit,
            debounceMilliseconds
        },
        onFocus: onInputFocus,
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(BaseAmountInput));


/***/ }),

/***/ 25192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90482);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57333);




const DEFAULT_MAX_LIMIT = 1e10 // 10,000,000,000
;
const CustomNumericFormat = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function NumericFormatCustom(props, ref) {
    const { onChange , maxLimit , value , debounceMilliseconds , ...other } = props;
    const [inputValue, setInputValue] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [focused, setFocused] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const timeoutId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!focused && (value || inputValue)) {
            setInputValue(value != null ? new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(Number(value)).toFixed() : "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focused,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_3__/* .NumericFormat */ .h3, {
        ...other,
        value: inputValue,
        getInputRef: ref,
        onValueChange: (param, param1)=>{
            let { floatValue , value  } = param, { event ={}  } = param1;
            setInputValue(value);
            const params = {
                ...event,
                target: {
                    ...event.target,
                    name: props.name,
                    floatValue,
                    value
                }
            };
            if (debounceMilliseconds) {
                timeoutId.current && clearTimeout(timeoutId.current);
                timeoutId.current = setTimeout(()=>{
                    onChange === null || onChange === void 0 ? void 0 : onChange(params);
                }, debounceMilliseconds);
            } else {
                onChange === null || onChange === void 0 ? void 0 : onChange(params);
            }
        },
        thousandSeparator: true,
        valueIsNumericString: true,
        allowedDecimalSeparators: [
            ","
        ],
        isAllowed: (values)=>{
            const floatValue = values.floatValue || 0;
            return floatValue <= (maxLimit || DEFAULT_MAX_LIMIT);
        },
        onBlur: (event)=>{
            var _other_onBlur;
            setFocused(false);
            (_other_onBlur = other.onBlur) === null || _other_onBlur === void 0 ? void 0 : _other_onBlur.call(other, event);
        },
        onFocus: (event)=>{
            var _other_onFocus;
            setFocused(true);
            (_other_onFocus = other.onFocus) === null || _other_onFocus === void 0 ? void 0 : _other_onFocus.call(other, event);
        },
        inputMode: "decimal"
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (CustomNumericFormat);


/***/ }),

/***/ 91094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_numeric__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14847);


/**
 * A wrapper of the {@link format} method from numeric utility.
 */ const NumericOutput = (param)=>{
    let { value , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,_utils_numeric__WEBPACK_IMPORTED_MODULE_1__/* .format */ .WU)(value, props)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NumericOutput);


/***/ }),

/***/ 75193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83321);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1880);
/* harmony import */ var _utils_static_import_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61930);







const BackButton = (param)=>{
    let { href  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const handleBackOnClick = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        if (!href) {
            router.back();
        } else {
            router.push(href, undefined, {
                shallow: false
            });
        }
    }, [
        router,
        href
    ]);
    const backIcon = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        return (0,_utils_static_import_icon__WEBPACK_IMPORTED_MODULE_5__/* .staticImportIcon */ .N)((0,_constants_index__WEBPACK_IMPORTED_MODULE_4__/* .isInstantWireMode */ .Zo)() ? _utils_static_import_icon__WEBPACK_IMPORTED_MODULE_5__/* .IconName.BACK_GRAY */ .u.BACK_GRAY : _utils_static_import_icon__WEBPACK_IMPORTED_MODULE_5__/* .IconName.BACK */ .u.BACK);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        "data-testid": "btn-back",
        className: "w-fit min-w-fit p-2 bg-[#1E2735] iw:bg-[#EAEAEA] iw:hover:bg-[#DFF1FF] rounded-full",
        onClick: handleBackOnClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: backIcon,
            alt: "back",
            className: "w-4 sm:w-6"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.memo)(BackButton));


/***/ }),

/***/ 89010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73680);
/* harmony import */ var _wallet_adapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33618);



const isCommitment = (value)=>typeof value === "string";
const useConfirmTransaction = ()=>{
    const { connection  } = (0,_wallet_adapter__WEBPACK_IMPORTED_MODULE_2__/* .useConnection */ .Rc)();
    const confirmTransaction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(txSignature) {
        let commitmentOrLatestBlockhash = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "finalized";
        const latestBlockhash = isCommitment(commitmentOrLatestBlockhash) ? await connection.getLatestBlockhash(commitmentOrLatestBlockhash) : commitmentOrLatestBlockhash;
        const [, confirmation] = await (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .toResultAsync */ .zM)(connection.confirmTransaction({
            signature: txSignature,
            ...latestBlockhash
        }));
        const error = !confirmation || confirmation.value.err;
        return [
            error,
            confirmation
        ];
    }, [
        connection
    ]);
    return {
        confirmTransaction
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useConfirmTransaction);


/***/ }),

/***/ 76243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_safely_send_tx_with_notice; }
});

// UNUSED EXPORTS: isKnownError

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/wallet/adapter.ts + 1 modules
var adapter = __webpack_require__(33618);
// EXTERNAL MODULE: ./src/hooks/use-confirmation-transaction.ts
var use_confirmation_transaction = __webpack_require__(89010);
// EXTERNAL MODULE: ./node_modules/@solana/web3.js/lib/index.browser.esm.js + 3 modules
var index_browser_esm = __webpack_require__(27632);
;// CONCATENATED MODULE: ./src/hooks/use-gasless-handling.ts




const useGaslessHandling = ()=>{
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { wallet , publicKey  } = (0,adapter/* useWallet */.Os)();
    return (0,react.useCallback)(async (tx)=>{
        if ((0,constants/* isChainSolana */.j2)()) return await tx.buildAndExecute();
        const { instructions , cleanupInstructions , signers  } = tx.compressIx(true);
        const transaction = new index_browser_esm.Transaction();
        for (const ix of instructions){
            transaction.add(ix);
        }
        for (const cIx of cleanupInstructions){
            transaction.add(cIx);
        }
        transaction.feePayer = publicKey !== null && publicKey !== void 0 ? publicKey : undefined;
        transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
        for (const s of signers){
            transaction.sign(s);
        }
        return await (wallet === null || wallet === void 0 ? void 0 : wallet.adapter).sendTransactionWithSigners(transaction, connection, signers);
    }, [
        connection,
        wallet,
        publicKey
    ]);
};
/* harmony default export */ var use_gasless_handling = (useGaslessHandling);

// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-toast-message.tsx + 1 modules
var use_toast_message = __webpack_require__(36625);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
;// CONCATENATED MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx











const KnownErrorTesters = {
    "0x1": [
        /Attempt to debit an account but found no record of a prior credit/,
        /custom program error: 0x1$/
    ],
    "wallet_refused": [
        /^refuse_send_transaction$/,
        /^user denied transaction signature$/,
        /^user denied sign transactions$/,
        /^WalletSignTransactionError$/,
        /^WalletSignTransactionError: Transaction rejected$/,
        /^WalletSignTransactionError: User rejected the request\.$/
    ]
};
const isKnownError = (error)=>{
    var _Object_entries_find;
    return (_Object_entries_find = Object.entries(KnownErrorTesters).find((param)=>{
        let [, testers] = param;
        return testers.some((tester)=>tester.test(error.message) || tester.test(String(error)));
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
};
const useSafelySendTxWithNotice = function() {
    let globalContextOrOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const globalOptions = (0,react.useMemo)(()=>typeof globalContextOrOptions === "string" ? {
            context: globalContextOrOptions
        } : globalContextOrOptions, [
        globalContextOrOptions
    ]);
    const { connection  } = (0,adapter/* useConnection */.Rc)();
    const { confirmTransaction  } = (0,use_confirmation_transaction/* default */.Z)();
    const { showMessage , showLoadingNotice  } = (0,use_toast_message/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    const gaslessEnabled = Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.is_gasless_mode_enabled);
    const sendTxWithGasless = use_gasless_handling();
    var _globalOptions_alwaysHideTxExplorerLink, _globalOptions_confirmationErrorMessage, _globalOptions_confirmationErrorTitle, _ref, _globalOptions_context, _globalOptions_errorMessage, _globalOptions_errorTitle, _globalOptions_gasless, _globalOptions_onBeforeShowingNotice, _globalOptions_successMessage, _globalOptions_successTitle, _globalOptions_throwOnError, _globalOptions_waitUntilConfirmed;
    const safelySendTxWithNotice = (0,react.useCallback)(/**
     * @throws never, unless `throwOnError` is set to `true`.
     */ async function(tx) {
        let { alwaysHideTxExplorerLink =(_globalOptions_alwaysHideTxExplorerLink = globalOptions.alwaysHideTxExplorerLink) !== null && _globalOptions_alwaysHideTxExplorerLink !== void 0 ? _globalOptions_alwaysHideTxExplorerLink : false , confirmationErrorMessage =(_globalOptions_confirmationErrorMessage = globalOptions.confirmationErrorMessage) !== null && _globalOptions_confirmationErrorMessage !== void 0 ? _globalOptions_confirmationErrorMessage : trans.common.tx_notice.unconfirmed_message , confirmationErrorTitle =(_ref = (_globalOptions_confirmationErrorTitle = globalOptions.confirmationErrorTitle) !== null && _globalOptions_confirmationErrorTitle !== void 0 ? _globalOptions_confirmationErrorTitle : globalOptions.errorTitle) !== null && _ref !== void 0 ? _ref : trans.common.tx_notice.error_title , context =(_globalOptions_context = globalOptions.context) !== null && _globalOptions_context !== void 0 ? _globalOptions_context : "common" , errorMessage =(_globalOptions_errorMessage = globalOptions.errorMessage) !== null && _globalOptions_errorMessage !== void 0 ? _globalOptions_errorMessage : trans.common.tx_notice.error_message , errorTitle =(_globalOptions_errorTitle = globalOptions.errorTitle) !== null && _globalOptions_errorTitle !== void 0 ? _globalOptions_errorTitle : trans.common.tx_notice.error_title , gasless =(_globalOptions_gasless = globalOptions.gasless) !== null && _globalOptions_gasless !== void 0 ? _globalOptions_gasless : gaslessEnabled , onBeforeShowingNotice =(_globalOptions_onBeforeShowingNotice = globalOptions.onBeforeShowingNotice) !== null && _globalOptions_onBeforeShowingNotice !== void 0 ? _globalOptions_onBeforeShowingNotice : ()=>true , primaryButton =globalOptions.primaryButton , snackbarOptions =globalOptions.snackbarOptions , successMessage =(_globalOptions_successMessage = globalOptions.successMessage) !== null && _globalOptions_successMessage !== void 0 ? _globalOptions_successMessage : trans.common.tx_notice.success_message , successTitle =(_globalOptions_successTitle = globalOptions.successTitle) !== null && _globalOptions_successTitle !== void 0 ? _globalOptions_successTitle : trans.common.tx_notice.success_title , throwOnError =(_globalOptions_throwOnError = globalOptions.throwOnError) !== null && _globalOptions_throwOnError !== void 0 ? _globalOptions_throwOnError : false , titleAppendix =globalOptions.titleAppendix , waitUntilConfirmed =(_globalOptions_waitUntilConfirmed = globalOptions.waitUntilConfirmed) !== null && _globalOptions_waitUntilConfirmed !== void 0 ? _globalOptions_waitUntilConfirmed : true  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const noticeElement = function(e) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return typeof e === "function" ? e(...args) : e;
        };
        const [error, signature] = await (0,helpers/* toResultAsync */.zM)("then" in tx ? tx : gasless && !(0,constants/* isChainSolana */.j2)() ? sendTxWithGasless(tx) : tx.buildAndExecute());
        if (error) {
            var _isKnownError;
            const errorKey = (_isKnownError = isKnownError(error)) !== null && _isKnownError !== void 0 ? _isKnownError : "unknown";
            const errorTroubleshootingByContext = trans.common.tx_notice.errors[errorKey];
            var _errorTroubleshootingByContext_common;
            const troubleshooting = [
                ...(_errorTroubleshootingByContext_common = errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext.common) !== null && _errorTroubleshootingByContext_common !== void 0 ? _errorTroubleshootingByContext_common : []
            ];
            if (context !== "common" && (errorTroubleshootingByContext === null || errorTroubleshootingByContext === void 0 ? void 0 : errorTroubleshootingByContext[context])) {
                var _errorTroubleshootingByContext_context;
                troubleshooting.splice(0, 0, ...(_errorTroubleshootingByContext_context = errorTroubleshootingByContext[context]) !== null && _errorTroubleshootingByContext_context !== void 0 ? _errorTroubleshootingByContext_context : []);
            }
            // eslint-disable-next-line no-console
            console.error("".concat(context, " send transaction error"), error, error.logs);
            if (onBeforeShowingNotice("error", error) !== false) {
                showMessage({
                    error,
                    message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: noticeElement(errorMessage, error)
                            }),
                            Boolean(troubleshooting.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-xs font-bold",
                                        children: trans.common.tx_notice.what_should_i_do_now
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        spacing: 0.5,
                                        children: troubleshooting.map((solution, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "li",
                                                className: "text-sm",
                                                children: solution
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }),
                    primaryButton: noticeElement(primaryButton, "error", error),
                    title: noticeElement(errorTitle, error),
                    titleAppendix: noticeElement(titleAppendix, "error", error),
                    type: "error"
                }, snackbarOptions);
            }
            if (throwOnError) throw error;
            return;
        }
        if (waitUntilConfirmed) {
            const latestBlockhash = await connection.getLatestBlockhash();
            const closeLoadingNotice = showLoadingNotice({
                lastValidBlockHeight: latestBlockhash.lastValidBlockHeight,
                signature
            });
            const [isTxConfirmed, { value: { err: confirmationError  }  }] = await confirmTransaction(signature, latestBlockhash);
            closeLoadingNotice();
            if (!isTxConfirmed && confirmationError) {
                // eslint-disable-next-line no-console
                console.error("".concat(context, " confirm transaction error"), confirmationError);
                if (onBeforeShowingNotice("confirmation_error", signature, confirmationError) !== false) {
                    showMessage({
                        message: noticeElement(confirmationErrorMessage, signature, error),
                        primaryButton: noticeElement(primaryButton, "confirmation_error", signature, error),
                        title: noticeElement(confirmationErrorTitle, signature, error),
                        titleAppendix: noticeElement(titleAppendix, "confirmation_error", signature, error),
                        type: "error",
                        txid: alwaysHideTxExplorerLink ? undefined : signature
                    }, snackbarOptions);
                }
                if (throwOnError) throw confirmationError;
                return;
            }
        }
        ;
        if (onBeforeShowingNotice("success", signature) !== false) {
            showMessage({
                message: noticeElement(successMessage, signature),
                primaryButton: noticeElement(primaryButton, "success", signature),
                title: noticeElement(successTitle, signature),
                titleAppendix: noticeElement(titleAppendix, "success", signature),
                type: "success",
                txid: alwaysHideTxExplorerLink ? undefined : signature
            }, snackbarOptions);
        }
        return signature;
    }, [
        confirmTransaction,
        connection,
        gaslessEnabled,
        globalOptions,
        sendTxWithGasless,
        showLoadingNotice,
        showMessage,
        trans
    ]);
    return {
        safelySendTxWithNotice
    };
};
/* harmony default export */ var use_safely_send_tx_with_notice = (useSafelySendTxWithNotice);


/***/ }),

/***/ 23953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pool_address_nemo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/MainLayout/index.tsx + 24 modules
var MainLayout = __webpack_require__(33509);
// EXTERNAL MODULE: ./node_modules/@orca-so/common-sdk/dist/index.js
var dist = __webpack_require__(66259);
// EXTERNAL MODULE: ./node_modules/@renec-foundation/nemoswap-sdk/dist/index.js
var nemoswap_sdk_dist = __webpack_require__(42800);
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/hooks/use-nemo-wallet.ts
var use_nemo_wallet = __webpack_require__(6200);
// EXTERNAL MODULE: ./src/hooks/use-safely-send-tx-with-notice.tsx + 1 modules
var use_safely_send_tx_with_notice = __webpack_require__(76243);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./src/hooks/use-tokens/index.ts + 1 modules
var use_tokens = __webpack_require__(28309);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
// EXTERNAL MODULE: ./src/providers/nemo-program/index.tsx
var nemo_program = __webpack_require__(67477);
// EXTERNAL MODULE: ./src/providers/pool/index.tsx + 2 modules
var pool = __webpack_require__(41725);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
// EXTERNAL MODULE: ./src/utils/helpers.liquidity.ts
var helpers_liquidity = __webpack_require__(69889);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/components/open-position/use-price-range.tsx




const usePriceRange = function(pool) {
    let defaultPriceRange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        new decimal/* default */.Z(0),
        new decimal/* default */.Z(0)
    ];
    const [priceRange, setPriceRange] = (0,react.useState)(defaultPriceRange);
    const [tickRange, setTickRange] = (0,react.useState)(null);
    const handleSetPriceRange = (0,react.useCallback)((newRange)=>{
        if (newRange[1].lt(newRange[0])) {
            [newRange[0], newRange[1]] = [
                newRange[1],
                newRange[0]
            ];
        }
        const roundPrice = (price)=>{
            var _pool_getTokenAInfo_decimals;
            const decimalsA = (_pool_getTokenAInfo_decimals = pool === null || pool === void 0 ? void 0 : pool.getTokenAInfo().decimals) !== null && _pool_getTokenAInfo_decimals !== void 0 ? _pool_getTokenAInfo_decimals : 0;
            var _pool_getTokenBInfo_decimals;
            const decimalsB = (_pool_getTokenBInfo_decimals = pool === null || pool === void 0 ? void 0 : pool.getTokenBInfo().decimals) !== null && _pool_getTokenBInfo_decimals !== void 0 ? _pool_getTokenBInfo_decimals : 0;
            var _pool_getData_tickSpacing;
            const tickSpacing = (_pool_getData_tickSpacing = pool === null || pool === void 0 ? void 0 : pool.getData().tickSpacing) !== null && _pool_getData_tickSpacing !== void 0 ? _pool_getData_tickSpacing : 1;
            const initializableTickIndex = nemoswap_sdk_dist.PriceMath.priceToInitializableTickIndex(price, decimalsA, decimalsB, tickSpacing);
            const roundedPrice = nemoswap_sdk_dist.PriceMath.tickIndexToPrice(initializableTickIndex, decimalsA, decimalsB);
            return [
                roundedPrice,
                initializableTickIndex
            ];
        };
        var _toResult_;
        const [price0, tick0] = (_toResult_ = (0,helpers/* toResult */.K8)(()=>roundPrice(newRange[0]))[1]) !== null && _toResult_ !== void 0 ? _toResult_ : [
            new decimal/* default */.Z(0),
            null
        ];
        var _toResult_1;
        const [price1, tick1] = (_toResult_1 = (0,helpers/* toResult */.K8)(()=>roundPrice(newRange[1]))[1]) !== null && _toResult_1 !== void 0 ? _toResult_1 : [
            new decimal/* default */.Z(0),
            null
        ];
        setPriceRange([
            price0,
            price1
        ]);
        setTickRange(tick0 === null || tick1 === null ? null : [
            tick0,
            tick1
        ]);
    }, [
        pool
    ]);
    (0,react.useEffect)(()=>{
        handleSetPriceRange(priceRange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pool
    ]);
    return {
        priceRange,
        tickRange,
        setPriceRange: handleSetPriceRange
    };
};
/* harmony default export */ var use_price_range = (usePriceRange);

// EXTERNAL MODULE: ./node_modules/@renec-foundation/nemoswap-sdk/dist/instructions/index.js
var instructions = __webpack_require__(8033);
// EXTERNAL MODULE: ./node_modules/@solana/spl-token/lib/index.browser.esm.js + 5 modules
var index_browser_esm = __webpack_require__(974);
;// CONCATENATED MODULE: ./src/components/open-position/utils.tsx




const TX_SIZE_LIMIT = 1232;
const ADDITIONAL_COST_OF_NOT_INIT_TICK_AT_EDGE = 32;
const BYTES_PER_TICK_ARRAY_IX = 51;
const TOKEN_AND_TOKEN = {
    numOfTickArrays: 10,
    txSize: 1208
};
const TOKEN_AND_RENEC = {
    numOfTickArrays: 7,
    txSize: 1223
};
const getInitTickArrayTx = async (client, whirlpool, tickLowerIndex, tickUpperIndex, funder)=>{
    const { tickSpacing  } = whirlpool.getData();
    const allSurroundingTicksArray = getAllSurroundingTicksArrayInRange(tickLowerIndex, tickUpperIndex, tickSpacing);
    const edgesUninitializedTickArrays = await nemoswap_sdk_dist.TickArrayUtil.getUninitializedArraysPDAs([
        tickLowerIndex,
        tickUpperIndex
    ], client.getContext().program.programId, whirlpool.getAddress(), tickSpacing, client.getFetcher(), true);
    const totalInitTickArraysIxs = calculateTotalNumberOfInitTickArrayIxs(whirlpool, 2 - edgesUninitializedTickArrays.length);
    // pick closet uninitialized tick array to the current tick due to tx size limit
    const surroundingUninitializedTickArrays = await getClosestUninitializedTickArray(client, whirlpool, allSurroundingTicksArray, tickSpacing, totalInitTickArraysIxs - edgesUninitializedTickArrays.length);
    // Construct the init tick array tx
    const initTickTx = constructTheInitTickArrayTx(client.getContext(), whirlpool.getAddress(), surroundingUninitializedTickArrays, edgesUninitializedTickArrays, funder);
    return initTickTx;
};
const getAllSurroundingTicksArrayInRange = (tickLower, tickUpper, tickSpacing)=>{
    const startTickLower = nemoswap_sdk_dist.TickUtil.getStartTickIndex(tickLower, tickSpacing);
    const startTickUpper = nemoswap_sdk_dist.TickUtil.getStartTickIndex(tickUpper, tickSpacing);
    // Get all start ticks in range
    const startTicks = [];
    const increment = nemoswap_sdk_dist.TICK_ARRAY_SIZE * tickSpacing;
    // start tick lower and upper are exclusive
    for(let i = startTickLower + increment; i < startTickUpper; i += increment){
        startTicks.push(i);
    }
    return startTicks;
};
const getClosestUninitializedTickArray = async (client, whirlpool, allSurroundingTicksArray, tickSpacing, maxIxs)=>{
    // Get all uninitialized ticks
    const initTickArrayStartPDAs = await nemoswap_sdk_dist.TickArrayUtil.getUninitializedArraysPDAs(allSurroundingTicksArray, client.getContext().program.programId, whirlpool.getAddress(), tickSpacing, client.getFetcher(), true);
    if (initTickArrayStartPDAs.length <= maxIxs) {
        return initTickArrayStartPDAs;
    }
    // sort ascending by start index
    initTickArrayStartPDAs.sort((a, b)=>a.startIndex - b.startIndex);
    const currentTickIndex = whirlpool.getData().tickCurrentIndex;
    // Get the start tick index that passes the current tick
    let index = -1;
    for(let i = 0; i < initTickArrayStartPDAs.length; i++){
        if (currentTickIndex < initTickArrayStartPDAs[i].startIndex) {
            index = i;
            break;
        } else if (currentTickIndex === initTickArrayStartPDAs[i].startIndex) {
            index = i + 1 // index of the next tick array
            ;
            break;
        }
    }
    if (index === -1 || index >= initTickArrayStartPDAs.length) {
        return [] // no tick arrays need to be initialized
        ;
    }
    // Distribute uninitializedIxs surrounding the current tick. Take left first
    let availableIxs = maxIxs;
    let maxLeft = index - 1;
    let maxRight = index;
    let pickFromLeft = true;
    const resultIndices = [];
    while(availableIxs > 0 && (maxLeft >= 0 || maxRight < initTickArrayStartPDAs.length)){
        if (pickFromLeft && availableIxs > 0 && maxLeft >= 0) {
            resultIndices.push(maxLeft);
            maxLeft--;
            availableIxs--;
        } else if (!pickFromLeft && availableIxs > 0 && maxRight < initTickArrayStartPDAs.length) {
            resultIndices.push(maxRight);
            maxRight++;
            availableIxs--;
        }
        pickFromLeft = !pickFromLeft;
    }
    const selectedPDAs = resultIndices.map((index)=>initTickArrayStartPDAs[index]);
    return selectedPDAs;
};
const constructTheInitTickArrayTx = (context, whirlpoolPubkey, surroundingUninitializedTickArrays, edgesUninitializedTickArrays, funder)=>{
    const provider = context.provider;
    const program = context.program;
    const txBuilder = new dist.TransactionBuilder(provider.connection, provider.wallet);
    surroundingUninitializedTickArrays.forEach((initTickArrayInfo)=>{
        txBuilder.addInstruction((0,instructions.initTickArrayIx)(program, {
            startTick: initTickArrayInfo.startIndex,
            tickArrayPda: initTickArrayInfo.pda,
            whirlpool: whirlpoolPubkey,
            funder: !!funder ? funder : provider.wallet.publicKey
        }));
    });
    edgesUninitializedTickArrays.forEach((initTickArrayInfo)=>{
        txBuilder.addInstruction((0,instructions.initTickArrayIx)(program, {
            startTick: initTickArrayInfo.startIndex,
            tickArrayPda: initTickArrayInfo.pda,
            whirlpool: whirlpoolPubkey,
            funder: !!funder ? funder : provider.wallet.publicKey
        }));
    });
    return txBuilder;
};
// Do this, since the simulate to calculation the tx size is slow
const calculateTotalNumberOfInitTickArrayIxs = (whirlpool, numOfEdgesArrayInitialized)=>{
    if (numOfEdgesArrayInitialized < 0) {
        throw new Error("numOfEdgesArrayInitialized cannot be negative");
    }
    let tickArrayIxCapacity;
    if (isWhirlpoolContainRenec(whirlpool)) {
        tickArrayIxCapacity = TOKEN_AND_RENEC;
    } else {
        tickArrayIxCapacity = TOKEN_AND_TOKEN;
    }
    // For one edge initialized, cost more 32 bytes. For a numOfTickArrays left, cost less 51 bytes
    tickArrayIxCapacity.txSize = tickArrayIxCapacity.txSize + ADDITIONAL_COST_OF_NOT_INIT_TICK_AT_EDGE * numOfEdgesArrayInitialized;
    while(tickArrayIxCapacity.txSize > TX_SIZE_LIMIT){
        tickArrayIxCapacity.numOfTickArrays--;
        tickArrayIxCapacity.txSize = tickArrayIxCapacity.txSize - BYTES_PER_TICK_ARRAY_IX;
    }
    return tickArrayIxCapacity.numOfTickArrays;
};
const isWhirlpoolContainRenec = (whirlpool)=>{
    const tokenMintA = whirlpool.getData().tokenMintA;
    const tokenMintB = whirlpool.getData().tokenMintB;
    return tokenMintA.equals(index_browser_esm.NATIVE_MINT) || tokenMintB.equals(index_browser_esm.NATIVE_MINT);
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/base/BaseAmountInput.tsx
var BaseAmountInput = __webpack_require__(93356);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
// EXTERNAL MODULE: ./src/components/base/TokenPicker/index.tsx + 14 modules
var TokenPicker = __webpack_require__(97383);
// EXTERNAL MODULE: ./src/components/common/BackButton.tsx
var BackButton = __webpack_require__(75193);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Repeat.js
var Repeat = __webpack_require__(40984);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/base/BaseDialog.tsx + 6 modules
var BaseDialog = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/components/base/CustomNumericFormat.tsx
var CustomNumericFormat = __webpack_require__(25192);
// EXTERNAL MODULE: ./src/components/base/NumericOutput.tsx
var NumericOutput = __webpack_require__(91094);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
;// CONCATENATED MODULE: ./src/components/open-position/styles.tsx


const StyledInput = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            padding: "11px 12px",
            borderRadius: "8px",
            border: "1px solid #3A3F5D",
            backgroundColor: "#2A3748",
            fontSize: "12px",
            lineHeight: "18px",
            color: "#E7E8EB",
            transition: "border 0.2s ease"
        },
        "& .MuiInput-input": {
            padding: "0 12px 0 0",
            fontSize: "14px",
            lineHeight: "20px"
        },
        "&.Mui-focused": {
            borderColor: "#fff"
        },
        "&.Mui-error": {
            borderColor: "#f44336"
        }
    }));

// EXTERNAL MODULE: ./src/constants/amplitude.ts
var constants_amplitude = __webpack_require__(78017);
// EXTERNAL MODULE: ./src/hooks/use-amplitude.ts + 61 modules
var use_amplitude = __webpack_require__(54341);
;// CONCATENATED MODULE: ./src/components/open-position/SetLiquidityDialog.tsx
















const SetLiquidityDialog = (param)=>{
    let { tokenIn , tokenOut , bPerAPrice , ratios , errors , isOpenSetLiquidity , onApply , pricesReverted , setPricesReverted , values: { minPrice , maxPrice  } , setFieldValue , setValues  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const amplitude = (0,use_amplitude/* default */.Z)();
    const endAdornment = pricesReverted ? "".concat(tokenIn.symbol, "/").concat(tokenOut.symbol) : "".concat(tokenOut.symbol, "/").concat(tokenIn.symbol);
    const handleApply = ()=>{
        if (!isEmpty_default()(errors)) return;
        onApply();
    };
    const handleSwitchPrices = (0,react.useCallback)(()=>{
        setPricesReverted(!pricesReverted);
        const newMinPrice = new decimal/* default */.Z(maxPrice || 0).pow(-1);
        const newMaxPrice = new decimal/* default */.Z(minPrice || 0).pow(-1);
        const decimals = !pricesReverted ? tokenIn.decimals : tokenOut.decimals;
        setValues((values)=>({
                ...values,
                minPrice: newMinPrice.isFinite() ? newMinPrice.toFixed(decimals) : "0",
                maxPrice: newMaxPrice.isFinite() ? newMaxPrice.toFixed(decimals) : "0"
            }), true);
        amplitude.track(constants_amplitude/* EVENT_NAMES.liquidity_deposit_revert_price */.K.liquidity_deposit_revert_price, {
            from_token: tokenIn.symbol,
            to_token: tokenOut.symbol
        });
    }, [
        amplitude,
        maxPrice,
        minPrice,
        pricesReverted,
        setPricesReverted,
        setValues,
        tokenIn.decimals,
        tokenIn.symbol,
        tokenOut.decimals,
        tokenOut.symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseDialog/* default */.Z, {
        "data-testid": "set-liquidity-dialog",
        title: trans.liquidity.open_position.set_liquidity_dialog_title,
        body: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            className: "mt-2 w-[30rem] max-w-full space-y-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "column",
                justifyContent: "space-between",
                alignItems: "start",
                className: "w-full",
                gap: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: 1,
                        "data-testid": "box-current-price",
                        className: "w-full flex-col md:flex-row md:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: "text-sm font-normal",
                                    children: [
                                        trans.liquidity.open_position.current_price,
                                        ":"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm font-bold",
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        "data-testid": "token-a-symbol",
                                        children: pricesReverted ? tokenOut.symbol : tokenIn.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        children: "="
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm font-bold",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericOutput/* default */.Z, {
                                            decimals: pricesReverted ? tokenIn.decimals : tokenOut.decimals,
                                            preserveSignificance: true,
                                            value: bPerAPrice === null || bPerAPrice === void 0 ? void 0 : bPerAPrice.pow(pricesReverted ? -1 : 1)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        "data-testid": "token-b-symbol",
                                        children: pricesReverted ? tokenIn.symbol : tokenOut.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: trans.liquidity.open_position.revert_prices_icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Repeat/* default */.Z, {
                                            "data-testid": "icon-swap-token",
                                            className: "cursor-pointer opacity-70 hover:opacity-100",
                                            fontSize: "small",
                                            onClick: handleSwitchPrices
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "mb-3 text-base font-semibold text-white",
                                children: trans.liquidity.open_position.min_price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                                inputProps: {
                                    "data-testid": "input-min-price",
                                    decimalScale: pricesReverted ? tokenIn.decimals : tokenOut.decimals
                                },
                                inputComponent: CustomNumericFormat/* default */.Z,
                                disableUnderline: true,
                                value: minPrice,
                                onChange: (event)=>setFieldValue("minPrice", event.target.value, true),
                                error: !!errors.minPrice,
                                endAdornment: endAdornment
                            }),
                            errors.minPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-xs text-[#f44336] pl-3 pt-1",
                                children: trans.liquidity.open_position.errors[errors.minPrice]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "mb-3 text-base font-semibold text-white",
                                children: trans.liquidity.open_position.max_price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                                inputProps: {
                                    "data-testid": "input-max-price",
                                    decimalScale: pricesReverted ? tokenIn.decimals : tokenOut.decimals
                                },
                                inputComponent: CustomNumericFormat/* default */.Z,
                                disableUnderline: true,
                                value: maxPrice,
                                onChange: (event)=>setFieldValue("maxPrice", event.target.value, true),
                                error: !!errors.maxPrice,
                                endAdornment: endAdornment
                            }),
                            errors.maxPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-xs text-[#f44336] pl-3 pt-1",
                                children: trans.liquidity.open_position.errors[errors.maxPrice]
                            })
                        ]
                    }),
                    (ratios === null || ratios === void 0 ? void 0 : ratios[0]) && (ratios === null || ratios === void 0 ? void 0 : ratios[1]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: 1,
                        "data-testid": "box-deposit-ratio",
                        className: "w-full flex-col md:flex-row md:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    className: "text-sm font-normal",
                                    children: [
                                        trans.liquidity.open_position.deposit_ratio,
                                        ":"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm font-bold",
                                        children: "".concat(ratios[0].times(100).toFixed(2), "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        children: tokenIn.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        children: "/"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm font-bold",
                                        children: "".concat(ratios[1].times(100).toFixed(2), "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm text-[#B0B2BE]",
                                        children: tokenOut.symbol
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }),
        isOpened: isOpenSetLiquidity,
        handleClose: ()=>false,
        showCloseButton: false,
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            display: "flex",
            flexDirection: "row",
            className: "w-full space-x-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                fullWidth: true,
                size: "xl",
                "data-testid": "apply-change",
                onClick: handleApply,
                children: trans.liquidity.open_position.apply
            })
        })
    });
};
/* harmony default export */ var open_position_SetLiquidityDialog = (/*#__PURE__*/(0,react.memo)(SetLiquidityDialog));

;// CONCATENATED MODULE: ./src/components/open-position/view.tsx















const View = (props)=>{
    var _maxApplicableTokenBalances_get;
    const { handleTokenAmountChange , tokenIn , tokenOut , isSubmitting , submitForm , values , setPriceRange , maxApplicableTokenBalances , isValid , usdRateA , usdRateB , errors , walletConnected , handleInputMaximumBalance , pricesReverted , onChangeRange , isOpenSetLiquidity , formattedMinPrice , formattedMaxPrice , insufficientBalanceMsg  } = props;
    const amplitude = (0,use_amplitude/* default */.Z)();
    const trans = (0,useTrans/* default */.Z)();
    const totalUsd = (0,react.useMemo)(()=>{
        const tokenMaxValueA = (0,numeric/* toDecimal */.YM)(values.tokenAmountA).times(usdRateA);
        const tokenMaxValueB = (0,numeric/* toDecimal */.YM)(values.tokenAmountB).times(usdRateB);
        return tokenMaxValueA.plus(tokenMaxValueB);
    }, [
        usdRateA,
        usdRateB,
        values.tokenAmountA,
        values.tokenAmountB
    ]);
    (0,react.useEffect)(()=>{
        if (!errors.minPrice && !errors.maxPrice && isOpenSetLiquidity) {
            setPriceRange(values.minPrice, values.maxPrice, pricesReverted);
        }
    }, [
        errors.minPrice,
        errors.maxPrice,
        values.minPrice,
        values.maxPrice,
        pricesReverted,
        setPriceRange,
        isOpenSetLiquidity
    ]);
    const endAdornment = pricesReverted ? "".concat(tokenIn.symbol, "/").concat(tokenOut.symbol) : "".concat(tokenOut.symbol, "/").concat(tokenIn.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
        "data-testid": "open-position-form",
        "data-pricesreverted": pricesReverted,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(open_position_SetLiquidityDialog, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "h-full mt-6",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        className: "md:w-[488px] w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* default */.Z, {
                            href: "/liquidity/browse"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        className: "md:w-[488px] sm:w-full p-7 rounded-[32px] bg-[#1E2735] sm:mb-14 mb-6",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "text-xl font-bold",
                                    children: trans.liquidity.open_position.add_new_position
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                justifyContent: "space-between",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        spacing: 1,
                                        className: "bg-[#222C3C] rounded-2xl px-4 py-3 w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            "data-testid": "box-price-range",
                                            spacing: 1,
                                            justifyContent: "space-between",
                                            alignItems: "start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    className: "w-full",
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "text-sm font-normal",
                                                            children: [
                                                                trans.liquidity.open_position.price_range,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                            "data-testid": "box-change",
                                                            direction: "row",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                            className: "relative",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                "data-testid": "change-liquidity-price",
                                                                className: "text-sm underline border-b cursor-pointer border-gradient text-gradient",
                                                                onClick: onChangeRange,
                                                                children: trans.liquidity.open_position.change
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    justifyContent: "end",
                                                    alignItems: "center",
                                                    spacing: 0.5,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            className: "text-sm font-bold",
                                                            "data-testid": "price-range",
                                                            children: [
                                                                formattedMinPrice,
                                                                " ~ ",
                                                                formattedMaxPrice
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            className: "text-sm text-[#B0B2BE]",
                                                            children: endAdornment
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                "data-testid": "box-token-a-amount",
                                                className: "w-full bg-[#141A23] rounded-2xl pt-8 px-8 pb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        direction: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                                className: "flex basis-full",
                                                                justifyContent: "center",
                                                                alignItems: "start",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    name: "tokenAmountA",
                                                                    label: tokenIn.symbol,
                                                                    children: (param)=>/*#__PURE__*/ {
                                                                        let { field , meta  } = param;
                                                                        return (0,jsx_runtime.jsx)(BaseAmountInput/* default */.Z, {
                                                                            ...field,
                                                                            value: field.value,
                                                                            "data-testid": "input-token-a-amount",
                                                                            onChange: (event)=>{
                                                                                field.onChange(event);
                                                                                handleTokenAmountChange(event.target.name, event.target.floatValue);
                                                                            },
                                                                            error: Boolean(meta.touched && meta.error)
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPicker/* default */.Z, {
                                                                "data-testid": "token-in",
                                                                nickName: "tokenA",
                                                                selectedToken: tokenIn,
                                                                disableDropdown: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "caption",
                                                            className: "text-sm text-right opacity-40",
                                                            children: [
                                                                "".concat(trans.liquidity.open_position.max_balance, ": "),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    "data-testid": "btn-input-token-balance",
                                                                    variant: "caption",
                                                                    onClick: handleInputMaximumBalance,
                                                                    className: "text-sm text-right cursor-pointer hover:underline",
                                                                    children: (0,numeric/* formatSafe */.g1)(((_maxApplicableTokenBalances_get = maxApplicableTokenBalances === null || maxApplicableTokenBalances === void 0 ? void 0 : maxApplicableTokenBalances.get(tokenIn.symbol)) === null || _maxApplicableTokenBalances_get === void 0 ? void 0 : _maxApplicableTokenBalances_get.toFixed(tokenIn.decimals)) || 0, tokenIn.decimals)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                className: "relative h-[4px] w-full",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    className: "absolute w-[34px] h-[34px] rounded-full bg-[#4B586A] top-[-17px] left-[50%] ml-[-17px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                                        className: "flex"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                "data-testid": "box-token-b-amount",
                                                className: "w-full bg-[#141A23] rounded-2xl pt-8 px-8 pb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        direction: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                                className: "flex basis-full",
                                                                justifyContent: "center",
                                                                alignItems: "start",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    name: "tokenAmountB",
                                                                    label: tokenOut.symbol,
                                                                    children: (param)=>/*#__PURE__*/ {
                                                                        let { field , meta  } = param;
                                                                        return (0,jsx_runtime.jsx)(BaseAmountInput/* default */.Z, {
                                                                            ...field,
                                                                            value: field.value,
                                                                            "data-testid": "input-token-b-amount",
                                                                            onChange: (event)=>{
                                                                                field.onChange(event);
                                                                                handleTokenAmountChange(event.target.name, event.target.floatValue);
                                                                            },
                                                                            error: Boolean(meta.touched && meta.error)
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPicker/* default */.Z, {
                                                                "data-testid": "token-out",
                                                                nickName: "tokenB",
                                                                selectedToken: tokenOut,
                                                                disableDropdown: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        className: "mt-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                            variant: "caption",
                                                            className: "text-sm text-right opacity-40",
                                                            children: [
                                                                "".concat(trans.liquidity.open_position.max_balance, ": "),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    "data-testid": "btn-output-token-balance",
                                                                    variant: "caption",
                                                                    onClick: handleInputMaximumBalance,
                                                                    className: "text-sm text-right cursor-pointer hover:underline",
                                                                    children: (0,numeric/* format */.WU)(maxApplicableTokenBalances === null || maxApplicableTokenBalances === void 0 ? void 0 : maxApplicableTokenBalances.get(tokenOut.symbol), tokenOut.decimals)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isValid && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        "data-testid": "txt-total-price",
                                        className: "w-full py-3",
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: "text-sm",
                                                children: trans.liquidity.open_position.total
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                className: "ml-6 text-sm",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        "data-testid": "total-amount-in-usd",
                                                        children: (0,numeric/* format */.WU)(totalUsd)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "ml-1 opacity-40",
                                                        children: "reUSD"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            "data-testid": "btn-confirm-deposit",
                                            fullWidth: true,
                                            size: "xl",
                                            onClick: ()=>{
                                                submitForm();
                                                if (!walletConnected) {
                                                    amplitude.track(use_amplitude/* EVENT_NAMES.liquidity_deposit_connect_wallet_on_form */.K.liquidity_deposit_connect_wallet_on_form);
                                                }
                                                if (!Object.keys(errors).length) {
                                                    amplitude.track(use_amplitude/* EVENT_NAMES.liquidity_deposit_submit */.K.liquidity_deposit_submit, {
                                                        from_token: tokenIn.symbol,
                                                        to_token: tokenOut.symbol,
                                                        min_price: values.minPrice,
                                                        max_price: values.maxPrice,
                                                        from_amount: values.tokenAmountA,
                                                        to_amount: values.tokenAmountB
                                                    });
                                                }
                                            },
                                            disabled: !isValid || Boolean(insufficientBalanceMsg),
                                            loading: isSubmitting,
                                            children: walletConnected ? insufficientBalanceMsg || trans.liquidity.open_position.add_new_position : trans.common.connect_wallet
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var view = (/*#__PURE__*/(0,react.memo)(View));

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
;// CONCATENATED MODULE: ./src/components/open-position/view.skeleton.tsx





const ViewSkeleton = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        className: "h-full",
        justifyContent: "space-between",
        alignItems: "center",
        "data-testid": "open-position-skeleton",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            className: "md:w-[488px] sm:w-full p-6 rounded-[32px] bg-[#1E2735] sm:my-14 my-6",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-xl font-bold",
                        children: trans.liquidity.open_position.add_new_position
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: "bg-[#222C3C] rounded-2xl px-3 py-4 w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    className: "text-sm font-normal",
                                                    children: [
                                                        trans.liquidity.open_position.price_range,
                                                        ":"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "end",
                                                alignItems: "center",
                                                spacing: 0.5,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    variant: "rounded",
                                                    width: 140
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            variant: "rounded",
                                            width: 80
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: "w-full bg-[#141A23] rounded-2xl pt-8 px-6 pb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    className: "flex basis-full",
                                                    justifyContent: "center",
                                                    alignItems: "start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: "rounded",
                                                        height: 25,
                                                        width: 70
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    variant: "rectangular",
                                                    height: 44,
                                                    width: 108,
                                                    sx: {
                                                        borderRadius: 320
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "rounded",
                                                width: 50,
                                                className: "ml-auto"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    className: "relative h-[4px] w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        justifyContent: "center",
                                        alignItems: "center",
                                        className: "absolute w-[34px] h-[34px] rounded-full bg-[#4B586A] top-[-17px] left-[50%] ml-[-17px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                            className: "flex"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    className: "w-full bg-[#141A23] rounded-2xl pt-8 px-6 pb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            direction: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    className: "flex basis-full",
                                                    justifyContent: "center",
                                                    alignItems: "start",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: "rounded",
                                                        height: 25,
                                                        width: 50
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    variant: "rectangular",
                                                    height: 44,
                                                    width: 108,
                                                    sx: {
                                                        borderRadius: 320
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                variant: "rounded",
                                                width: 40,
                                                className: "ml-auto"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            className: "w-full py-3",
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rounded",
                                    height: 25,
                                    width: 50
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rounded",
                                    height: 25,
                                    width: 80,
                                    className: "ml-6"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                color: "secondary",
                                size: "large",
                                fullWidth: true,
                                className: "bg-gradient-btn border-none relative rounded-full h-[60px] normal-case",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    variant: "rounded",
                                    width: 120,
                                    className: "mx-auto"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var view_skeleton = (ViewSkeleton);

;// CONCATENATED MODULE: ./src/components/open-position/container.tsx






















const SLIPPAGE = dist.Percentage.fromDecimal(new decimal/* default */.Z(1));
const DEFAULT_MODIFYING_RATE = 1 - 0.08 // range 8%
;
const Container = (props)=>{
    const { poolAddress  } = props;
    const trans = (0,useTrans/* default */.Z)();
    const { getPools , pools: allPools  } = (0,pool/* usePools */.O)("none");
    const { client  } = (0,nemo_program/* useNemoProgram */.J)();
    (0,react.useEffect)(()=>{
        getPools([
            poolAddress
        ], {
            refreshMetadata: true,
            refreshWhirlpool: true
        });
    }, [
        getPools,
        poolAddress
    ]);
    const { data: rateData  } = (0,use_settings/* useRemitanoRate */.T)();
    const { connectWallet , publicKey  } = (0,use_nemo_wallet/* default */.Z)();
    const { balances: userBalances  } = (0,use_balances/* useBalances */.l)();
    const { safelySendTxWithNotice  } = (0,use_safely_send_tx_with_notice/* default */.Z)("create_position");
    const router = (0,next_router.useRouter)();
    const { getTokenInfo , renecTokenInfo , reUsdTokenInfo  } = (0,use_tokens/* useTokens */.rU)();
    const formRef = (0,react.useRef)(null);
    const [currentPool, currentPair] = (0,react.useMemo)(()=>{
        var _allPools_find;
        const { whirlpool  } = (_allPools_find = allPools.find((p)=>{
            var _p_whirlpool;
            return ((_p_whirlpool = p.whirlpool) === null || _p_whirlpool === void 0 ? void 0 : _p_whirlpool.getAddress().toBase58()) === poolAddress;
        })) !== null && _allPools_find !== void 0 ? _allPools_find : {};
        if (whirlpool) {
            const whirlPoolData = whirlpool.getData();
            const tokenA = getTokenInfo(whirlPoolData.tokenMintA.toBase58());
            const tokenB = getTokenInfo(whirlPoolData.tokenMintB.toBase58());
            if (tokenA && tokenB) {
                const pair = [
                    {
                        ...tokenA,
                        nickName: "tokenA",
                        decimals: whirlpool.getTokenAInfo().decimals
                    },
                    {
                        ...tokenB,
                        nickName: "tokenB",
                        decimals: whirlpool.getTokenBInfo().decimals
                    }
                ];
                return [
                    whirlpool,
                    pair
                ];
            }
        }
        return [
            null,
            null
        ];
    }, [
        allPools,
        poolAddress,
        getTokenInfo
    ]);
    const bPerAPrice = (0,react.useMemo)(()=>currentPool && nemoswap_sdk_dist.PriceMath.sqrtPriceX64ToPrice(currentPool.getData().sqrtPrice, currentPool.getTokenAInfo().decimals, currentPool.getTokenBInfo().decimals), [
        currentPool
    ]);
    const { priceRange , tickRange , setPriceRange  } = use_price_range(currentPool !== null && currentPool !== void 0 ? currentPool : undefined);
    const [tokenIn, tokenOut] = (0,react.useMemo)(()=>currentPair || [], [
        currentPair
    ]);
    const [fieldNameOfMaxAmount, setFieldNameOfMaxAmount] = (0,react.useState)("tokenAmountA");
    const [maxAmount, setMaxAmount] = (0,react.useState)(new decimal/* default */.Z(0));
    const [pricesReverted, setPricesReverted] = (0,react.useState)(false);
    const [isOpenSetLiquidity, setIsOpenSetLiquidity] = (0,react.useState)(false);
    const [usdRateA, usdRateB] = (0,react.useMemo)(()=>{
        return currentPool && ((0,helpers_liquidity/* getTokensRate */.C)({
            pool: currentPool,
            tokenAddress: reUsdTokenInfo.address,
            tokenUSDRate: (rateData === null || rateData === void 0 ? void 0 : rateData.REUSD) || 0
        }) || (0,helpers_liquidity/* getTokensRate */.C)({
            pool: currentPool,
            tokenAddress: renecTokenInfo.address,
            tokenUSDRate: (rateData === null || rateData === void 0 ? void 0 : rateData.RENEC) || 0
        })) || [
            new decimal/* default */.Z(0),
            new decimal/* default */.Z(0)
        ];
    }, [
        currentPool,
        renecTokenInfo,
        reUsdTokenInfo,
        rateData
    ]);
    const insufficientBalanceMsg = (0,react.useMemo)(()=>publicKey && new decimal/* default */.Z(userBalances["RENEC"] || 0).lte(0) ? trans.home.insufficient_balance : "", [
        publicKey,
        trans.home.insufficient_balance,
        userBalances
    ]);
    const ratios = (0,react.useMemo)(()=>{
        if (currentPool && tickRange) {
            const tokenAInfo = currentPool.getTokenAInfo();
            const tokenBInfo = currentPool.getTokenBInfo();
            const { tickCurrentIndex  } = currentPool.getData();
            const [tickLowerIndex, tickUpperIndex] = tickRange;
            let inputToken = tokenAInfo;
            if (tickLowerIndex <= tickCurrentIndex) {
                inputToken = tokenBInfo;
            }
            const [quoteErr, quote] = (0,helpers/* toResult */.K8)(()=>(0,nemoswap_sdk_dist.increaseLiquidityQuoteByInputToken)(inputToken.mint, new decimal/* default */.Z(1), tickLowerIndex, tickUpperIndex, SLIPPAGE, currentPool));
            if (quote) {
                // console.log('quote.liquidityAmount', DecimalUtil.fromU64(quote.liquidityAmount, tokenAInfo.decimals).toString())
                // console.log('quote.tokenEstA', DecimalUtil.fromU64(quote.tokenEstA, tokenAInfo.decimals).toString())
                // console.log('quote.tokenEstB', DecimalUtil.fromU64(quote.tokenEstB, tokenBInfo.decimals).toString())
                // console.log('quote.tokenMaxA', DecimalUtil.fromU64(quote.tokenMaxA, tokenAInfo.decimals).toString())
                // console.log('quote.tokenMaxB', DecimalUtil.fromU64(quote.tokenMaxB, tokenBInfo.decimals).toString())
                const tokenAEstAmount = dist.DecimalUtil.fromU64(quote.tokenEstA, tokenAInfo.decimals);
                const tokenBEstAmount = dist.DecimalUtil.fromU64(quote.tokenEstB, tokenBInfo.decimals);
                const tokenMaxValueA = tokenAEstAmount.times(usdRateA);
                const tokenMaxValueB = tokenBEstAmount.times(usdRateB);
                const total = tokenMaxValueA.plus(tokenMaxValueB);
                if (total.eq(0)) return null;
                const ratioA = tokenMaxValueA.div(total);
                const ratioB = tokenMaxValueB.div(total);
                return [
                    ratioA,
                    ratioB
                ];
            } else {
                ;
            }
        }
        return null;
    }, [
        currentPool,
        tickRange,
        usdRateA,
        usdRateB
    ]);
    const initialValues = (0,react.useMemo)(()=>({
            minPrice: "",
            maxPrice: "",
            tokenAmountA: 0,
            tokenAmountB: 0
        }), []);
    (0,react.useEffect)(()=>{
        if (currentPool) {
            const { sqrtPrice  } = currentPool.getData();
            const tokenAInfo = currentPool.getTokenAInfo();
            const tokenBInfo = currentPool.getTokenBInfo();
            const bPerAPrice = nemoswap_sdk_dist.PriceMath.sqrtPriceX64ToPrice(sqrtPrice, tokenAInfo.decimals, tokenBInfo.decimals);
            const lowerPrice = bPerAPrice.times(DEFAULT_MODIFYING_RATE);
            const upperPrice = bPerAPrice.div(DEFAULT_MODIFYING_RATE);
            setPriceRange([
                lowerPrice,
                upperPrice
            ]);
        }
    }, [
        currentPool,
        setPriceRange
    ]);
    const orderedPriceRange = (0,react.useMemo)(()=>{
        const [minPrice, maxPrice] = priceRange;
        const orderedMinPrice = pricesReverted ? maxPrice.pow(-1) : minPrice;
        const orderedMaxPrice = pricesReverted ? minPrice.pow(-1) : maxPrice;
        const finiteMinPrice = orderedMinPrice.isFinite() ? orderedMinPrice : new decimal/* default */.Z(0);
        const finiteMaxPrice = orderedMaxPrice.isFinite() ? orderedMaxPrice : new decimal/* default */.Z(0);
        return [
            finiteMinPrice,
            finiteMaxPrice
        ];
    }, [
        priceRange,
        pricesReverted
    ]);
    const [formattedMinPrice, formattedMaxPrice] = (0,react.useMemo)(()=>tokenIn && tokenOut ? (0,numeric/* formatRange */.nS)(orderedPriceRange, pricesReverted ? tokenIn.decimals : tokenOut.decimals) : [
            "",
            ""
        ], [
        orderedPriceRange,
        pricesReverted,
        tokenIn,
        tokenOut
    ]);
    const quoteByToken = (0,react.useCallback)((token, amount)=>{
        if (currentPool && tickRange) {
            try {
                return (0,nemoswap_sdk_dist.increaseLiquidityQuoteByInputToken)(token.mint, amount, tickRange[0], tickRange[1], SLIPPAGE, currentPool);
            } catch (e) {
                console.error("e ", e);
                return null;
            }
        }
    }, [
        currentPool,
        tickRange
    ]);
    const maxPriceByTokenPair = (0,react.useCallback)((maxTokenAAmount, maxTokenBAmount)=>{
        if (currentPool) {
            const tokenAInfo = currentPool.getTokenAInfo();
            const tokenBInfo = currentPool.getTokenBInfo();
            const quoteA = quoteByToken(tokenAInfo, maxTokenAAmount);
            const quoteB = quoteByToken(tokenBInfo, maxTokenBAmount);
            // If the quote is not available, then we can't calculate a maximum price
            if (!quoteA || !quoteB) return [
                maxTokenAAmount,
                maxTokenBAmount
            ];
            const quoteATokenAEstAmount = dist.DecimalUtil.fromU64(quoteA === null || quoteA === void 0 ? void 0 : quoteA.tokenEstA, tokenAInfo.decimals);
            const quoteATokenBEstAmount = dist.DecimalUtil.fromU64(quoteA === null || quoteA === void 0 ? void 0 : quoteA.tokenEstB, tokenBInfo.decimals);
            const quoteBTokenAEstAmount = dist.DecimalUtil.fromU64(quoteB === null || quoteB === void 0 ? void 0 : quoteB.tokenEstA, tokenAInfo.decimals);
            const quoteBTokenBEstAmount = dist.DecimalUtil.fromU64(quoteB === null || quoteB === void 0 ? void 0 : quoteB.tokenEstB, tokenBInfo.decimals);
            const totalMax = maxTokenAAmount.plus(maxTokenBAmount);
            if (totalMax.greaterThan(quoteATokenAEstAmount.plus(quoteATokenBEstAmount))) {
                setFieldNameOfMaxAmount("tokenAmountA");
                setMaxAmount(quoteATokenAEstAmount);
                return [
                    quoteATokenAEstAmount,
                    quoteATokenBEstAmount
                ];
            } else {
                setFieldNameOfMaxAmount("tokenAmountB");
                setMaxAmount(quoteBTokenBEstAmount);
                return [
                    quoteBTokenAEstAmount,
                    quoteBTokenBEstAmount
                ];
            }
        }
        return [
            maxTokenAAmount,
            maxTokenBAmount
        ];
    }, [
        currentPool,
        quoteByToken
    ]);
    const maxApplicableTokenBalances = (0,react.useMemo)(()=>{
        if (userBalances && ratios && tokenIn && tokenOut) {
            const [ratioA, ratioB] = ratios;
            const tokenBalanceA = new decimal/* default */.Z(userBalances[tokenIn.symbol] || 0);
            const tokenBalanceB = new decimal/* default */.Z(userBalances[tokenOut.symbol] || 0);
            let tokenMaxValueA = tokenBalanceA.times(usdRateA);
            let tokenMaxValueB = tokenBalanceB.times(usdRateB);
            const totalMaxValueComputedByA = tokenMaxValueA.div(ratioA);
            const totalMaxValueComputedByB = tokenMaxValueB.div(ratioB);
            if (totalMaxValueComputedByA.greaterThan(totalMaxValueComputedByB)) {
                tokenMaxValueA = totalMaxValueComputedByB.minus(tokenMaxValueB);
            } else if (totalMaxValueComputedByB.greaterThan(totalMaxValueComputedByA)) {
                tokenMaxValueB = totalMaxValueComputedByA.minus(tokenMaxValueA);
            }
            const [tokenMaxAmountA, tokenMaxAmountB] = maxPriceByTokenPair(tokenMaxValueA.div(usdRateA), tokenMaxValueB.div(usdRateB));
            const result = new Map([
                [
                    tokenIn.symbol,
                    tokenMaxAmountA
                ],
                [
                    tokenOut.symbol,
                    tokenMaxAmountB
                ]
            ]);
            return result;
        }
        return null;
    }, [
        userBalances,
        ratios,
        tokenIn,
        tokenOut,
        usdRateA,
        usdRateB,
        maxPriceByTokenPair
    ]);
    const submitOpenPosition = (0,react.useCallback)(async (values, setSubmitting)=>{
        if (!publicKey) {
            connectWallet();
        } else if (currentPool && tickRange) {
            const tokenAInfo = currentPool.getTokenAInfo();
            const tokenBInfo = currentPool.getTokenBInfo();
            const { tickCurrentIndex  } = currentPool.getData();
            const [tickLowerIndex, tickUpperIndex] = tickRange;
            const initTickTx = await getInitTickArrayTx(client, currentPool, tickLowerIndex, tickUpperIndex);
            let inputToken = tokenAInfo;
            let inputTokenAmount = new decimal/* default */.Z(values.tokenAmountA);
            if (tickLowerIndex <= tickCurrentIndex) {
                inputToken = tokenBInfo;
                inputTokenAmount = new decimal/* default */.Z(values.tokenAmountB);
            }
            const quote = (0,nemoswap_sdk_dist.increaseLiquidityQuoteByInputToken)(inputToken.mint, inputTokenAmount, tickLowerIndex, tickUpperIndex, SLIPPAGE, currentPool);
            setSubmitting(true);
            const { tx  } = await currentPool.openPosition(tickLowerIndex, tickUpperIndex, quote, publicKey);
            if (initTickTx) {
                tx.prependInstruction(initTickTx.compressIx(true));
            }
            const txid = await safelySendTxWithNotice(tx, {
                gasless: false,
                errorTitle: trans.liquidity.open_position.open_position_failed,
                successTitle: trans.liquidity.open_position.open_position_successfully
            });
            if (txid) {
                setTimeout(()=>{
                    router.push("/liquidity/portfolio");
                }, 1000);
            }
        }
        setSubmitting(false);
    }, [
        client,
        connectWallet,
        currentPool,
        publicKey,
        router,
        safelySendTxWithNotice,
        tickRange,
        trans.liquidity.open_position.open_position_failed,
        trans.liquidity.open_position.open_position_successfully
    ]);
    const handleTokenAmountChange = (0,react.useCallback)((currentFieldName, currentFieldStringValue)=>{
        const { setFieldValue  } = (formRef === null || formRef === void 0 ? void 0 : formRef.current) || {};
        if (setFieldValue) {
            if (currentPool) {
                const tokenAInfo = currentPool.getTokenAInfo();
                const tokenBInfo = currentPool.getTokenBInfo();
                const inputToken = currentFieldName === "tokenAmountA" ? tokenAInfo : tokenBInfo;
                const inputTokenAmount = (0,numeric/* toDecimal */.YM)(String(currentFieldStringValue || 0));
                const quote = quoteByToken(inputToken, inputTokenAmount);
                if (!quote) {
                    if (currentFieldName === "tokenAmountA") {
                        setFieldValue("tokenAmountB", 0);
                    } else if (currentFieldName === "tokenAmountB") {
                        setFieldValue("tokenAmountA", 0);
                    }
                    return;
                }
                const tokenAEstAmount = dist.DecimalUtil.fromU64(quote.tokenEstA, tokenAInfo.decimals);
                const tokenBEstAmount = dist.DecimalUtil.fromU64(quote.tokenEstB, tokenBInfo.decimals);
                if (currentFieldName === "tokenAmountA") {
                    setFieldValue("tokenAmountB", tokenBEstAmount.toNumber());
                } else if (currentFieldName === "tokenAmountB") {
                    setFieldValue("tokenAmountA", tokenAEstAmount.toNumber());
                }
            }
        }
    }, [
        currentPool,
        quoteByToken
    ]);
    const setPriceRangeSafe = (0,react.useCallback)((minPrice, maxPrice, reverted)=>{
        const [minValue, maxValue] = [
            minPrice,
            maxPrice
        ].map((price)=>{
            let priceDecimal;
            try {
                priceDecimal = new decimal/* default */.Z(price).pow(reverted ? -1 : 1);
            } catch (e) {
                priceDecimal = new decimal/* default */.Z(0);
            }
            return priceDecimal.isFinite() ? priceDecimal : new decimal/* default */.Z(0);
        });
        setPriceRange(reverted ? [
            maxValue,
            minValue
        ] : [
            minValue,
            maxValue
        ]);
    }, [
        setPriceRange
    ]);
    const handleInputMaximumBalance = (0,react.useCallback)(()=>{
        const { setFieldValue  } = (formRef === null || formRef === void 0 ? void 0 : formRef.current) || {};
        if (!setFieldValue) return;
        setFieldValue(fieldNameOfMaxAmount, maxAmount.toNumber());
        handleTokenAmountChange(fieldNameOfMaxAmount, maxAmount.toNumber());
    }, [
        fieldNameOfMaxAmount,
        maxAmount,
        handleTokenAmountChange
    ]);
    const onApply = (0,react.useCallback)(()=>setIsOpenSetLiquidity(false), []);
    const onChangeRange = (0,react.useCallback)(()=>setIsOpenSetLiquidity(true), []);
    (0,react.useEffect)(()=>{
        if (!isOpenSetLiquidity) {
            var _formRef_current;
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.setValues((values)=>({
                    ...values,
                    minPrice: (0,numeric/* toDecimal */.YM)(formattedMinPrice).toFixed(),
                    maxPrice: (0,numeric/* toDecimal */.YM)(formattedMaxPrice).toFixed()
                }), true);
        }
    }, [
        formattedMaxPrice,
        formattedMinPrice,
        isOpenSetLiquidity
    ]);
    (0,react.useEffect)(()=>{
        var _formRef_current;
        if (!isOpenSetLiquidity && ((_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.values.tokenAmountA)) {
            var _formRef_current1;
            handleTokenAmountChange("tokenAmountA", Number((_formRef_current1 = formRef.current) === null || _formRef_current1 === void 0 ? void 0 : _formRef_current1.values.tokenAmountA));
        }
    }, [
        handleTokenAmountChange,
        isOpenSetLiquidity
    ]);
    if (!(tokenIn && tokenOut && currentPool)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(view_skeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        innerRef: formRef,
        initialValues: initialValues,
        validate: (values)=>{
            const errors = {};
            if (+values.maxPrice <= +values.minPrice) {
                errors.maxPrice = "must_be_gt_min_price";
                errors.minPrice = "must_be_lt_max_price";
            }
            if (isNaN(parseFloat(values.minPrice))) {
                errors.minPrice = "must_be_a_number";
            }
            if (isNaN(parseFloat(values.maxPrice))) {
                errors.maxPrice = "must_be_a_number";
            }
            return errors;
        },
        onSubmit: (values, param)=>{
            let { setSubmitting  } = param;
            submitOpenPosition(values, setSubmitting);
        },
        children: (formProps)=>{
            const computedProps = {
                ...formProps,
                handleTokenAmountChange,
                tokenIn,
                tokenOut,
                bPerAPrice,
                setPriceRange: setPriceRangeSafe,
                maxApplicableTokenBalances,
                ratios,
                usdRateA,
                usdRateB,
                walletConnected: !!publicKey,
                handleInputMaximumBalance,
                pricesReverted,
                setPricesReverted,
                onApply,
                onChangeRange,
                isOpenSetLiquidity,
                formattedMinPrice,
                formattedMaxPrice,
                insufficientBalanceMsg
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {
                ...computedProps
            });
        }
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/open-position/index.tsx


;// CONCATENATED MODULE: ./src/pages/liquidity/open-position/[pool-address].nemo.tsx



const OpenPositionPage = (param)=>{
    let { poolAddress  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* MainLayout */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
            poolAddress: poolAddress
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _pool_address_nemo = (OpenPositionPage);


/***/ }),

/***/ 69889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getTokensRate; }
/* harmony export */ });
/* harmony import */ var _renec_foundation_nemoswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42800);
/* harmony import */ var _renec_foundation_nemoswap_sdk__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_renec_foundation_nemoswap_sdk__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90482);


const getTokensRate = (params)=>{
    const { pool , tokenAddress , tokenUSDRate  } = params;
    const tokenAInfo = pool.getTokenAInfo();
    const tokenBInfo = pool.getTokenBInfo();
    const tokenMintAddressA = tokenAInfo.mint.toBase58();
    const tokenMintAddressB = tokenBInfo.mint.toBase58();
    if (![
        tokenMintAddressA,
        tokenMintAddressB
    ].includes(tokenAddress)) {
        return null;
    }
    const { sqrtPrice  } = pool.getData();
    const bPerAPrice = _renec_foundation_nemoswap_sdk__WEBPACK_IMPORTED_MODULE_0__.PriceMath.sqrtPriceX64ToPrice(sqrtPrice, tokenAInfo.decimals, tokenBInfo.decimals);
    const aPerBPrice = _renec_foundation_nemoswap_sdk__WEBPACK_IMPORTED_MODULE_0__.PriceMath.invertPrice(bPerAPrice, tokenAInfo.decimals, tokenBInfo.decimals);
    let usdRateA = new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(1);
    let usdRateB = new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(1);
    if (tokenMintAddressA === tokenAddress) {
        usdRateA = usdRateA.times(tokenUSDRate);
        usdRateB = usdRateB.times(new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(tokenUSDRate).times(aPerBPrice));
    } else {
        usdRateA = usdRateA.times(new decimal_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(tokenUSDRate).times(bPerAPrice));
        usdRateB = usdRateB.times(tokenUSDRate);
    }
    return [
        usdRateA,
        usdRateB
    ];
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,7333,9597,2833,9774,2888,179], function() { return __webpack_exec__(22059); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);